<template>
  <div>
    <b-container fluid>
      <!-- <div class="alert alert-success mt-3">
        Enjoy 30% off on all upgrades this weekend.
        <b-link :to="{ name: 'upgrade' }">Upgrade NOW</b-link>
      </div> -->

      <p class="text-center title">
        <span class="ffb">{{
          start_config.structure == "Section"
            ? start_config.course
            : start_config.title
        }}</span>
      </p>

      <div class="flex-actions mt-lg-3">
        <div class="timer-flexes text-right">
          <div class="timer-flexes-item timer-flexes-item-1">
            <Timer
              @autosubmit="autoSubmit"
              :forcesubmit="forcesubmit"
              class="timer mr-lg-3 mr-1 pt-1"
            ></Timer>
          </div>
          <div class="timer-flexes-item timer-flexes-item-2">
            <miniTimer
              v-if="
                start_config.mode == 'Speed' || start_config.mode == 'Accuracy'
              "
              class="mr-lg-5 pt-lg-3 mt-2 mt-lg-0 mr-2 pt-1"
              :questionTrackId="currentquestionid"
              @makeFalse="
                questionChanged = false;
                changequestion = false;
              "
              @elapsed="changequestion = true"
              :questionChanged="questionChanged"
            ></miniTimer>
          </div>
        </div>

        <b-icon-calculator-fill
          @click="$bvModal.show('modal-calculator')"
          font-scale="3"
          class="cpoi mr-lg-5 mr-2"
        ></b-icon-calculator-fill>

        <b-button class="subbtn p-lg-1 p-2" @click="forceSubmit"
          >Submit</b-button
        >
      </div>

      <!-- Overlay when User submits the test or the submit button is triggered implicitly -->

      <b-overlay
        :show="submitting"
        rounded
        opacity="0.6"
        spinner-type="grow"
        spinner-small
        spinner-variant="primary"
        class="w-100"
      >
        <template v-slot:overlay>
          <div class="text-center">
            <b-icon-arrow-clockwise
              font-scale="2"
              animation="spin"
            ></b-icon-arrow-clockwise>

            <p>Submitting... Please wait</p>
          </div>
        </template>

        <b-row class="p-2">
          <!-- Calculator Modal -->
          <b-modal id="modal-calculator" title="Quick Calculator" hide-footer>
            <template #default>
              <b-alert show variant="danger">
                Expression can contain only one each of x² and &#8730; at a
                time.
              </b-alert>

              <div class="screen">
                <b-form-input
                  :class="result"
                  class="p-4 text-right expre"
                  v-model="calcexpre"
                  type="text"
                ></b-form-input>
              </div>

              <div class="calcbtns">
                <table>
                  <tr>
                    <td class="caltd">
                      <b-button class="calcbtn" value="9" @click="addText('9')"
                        >9</b-button
                      >
                    </td>

                    <td class="caltd">
                      <b-button class="calcbtn" @click="addText('8')"
                        >8</b-button
                      >
                    </td>

                    <td>
                      <b-button class="calcbtn" @click="addText('7')"
                        >7</b-button
                      >
                    </td>

                    <td>
                      <b-button class="calcbtn" @click="addText('/')"
                        >&divide;</b-button
                      >
                    </td>

                    <td>
                      <b-button class="calcbtn" @click="clearText()"
                        >C</b-button
                      >
                    </td>

                    <td>
                      <b-button class="calcbtn" @click="delExpression()"
                        >Del</b-button
                      >
                    </td>
                  </tr>

                  <tr>
                    <td class="caltd">
                      <b-button class="calcbtn" @click="addText('4')"
                        >4</b-button
                      >
                    </td>

                    <td class="caltd">
                      <b-button class="calcbtn" @click="addText('5')"
                        >5</b-button
                      >
                    </td>

                    <td>
                      <b-button class="calcbtn" @click="addText('6')"
                        >6</b-button
                      >
                    </td>

                    <td>
                      <b-button class="calcbtn" @click="addText('*')"
                        >*</b-button
                      >
                    </td>

                    <td>
                      <b-button class="calcbtn" @click="addText('(')"
                        >(</b-button
                      >
                    </td>

                    <td>
                      <b-button class="calcbtn" @click="addText(')')"
                        >)</b-button
                      >
                    </td>
                  </tr>

                  <tr>
                    <td class="caltd">
                      <b-button class="calcbtn" @click="addText('1')"
                        >1</b-button
                      >
                    </td>

                    <td class="caltd">
                      <b-button class="calcbtn" @click="addText('2')"
                        >2</b-button
                      >
                    </td>

                    <td>
                      <b-button class="calcbtn" @click="addText('3')"
                        >3</b-button
                      >
                    </td>

                    <td>
                      <b-button class="calcbtn" @click="addText('-')"
                        >-</b-button
                      >
                    </td>

                    <td>
                      <b-button class="calcbtn" @click="addText('²')">
                        x

                        <sup>2</sup>
                      </b-button>
                    </td>

                    <td>
                      <b-button class="calcbtn" @click="addText('√')"
                        >&#8730;</b-button
                      >
                    </td>
                  </tr>

                  <tr>
                    <td class="caltd">
                      <b-button class="calcbtn" @click="addText('0')"
                        >0</b-button
                      >
                    </td>

                    <td class="caltd">
                      <b-button class="calcbtn" @click="addText('.')"
                        >.</b-button
                      >
                    </td>

                    <td>
                      <b-button class="calcbtn" @click="addText('%')"
                        >%</b-button
                      >
                    </td>

                    <td>
                      <b-button class="calcbtn" @click="addText('+')"
                        >+</b-button
                      >
                    </td>

                    <td colspan="2">
                      <b-button class="calcbtn" @click="evalE()">=</b-button>
                    </td>
                  </tr>
                </table>
              </div>
            </template>
          </b-modal>

          <b-modal
            id="modal-leave"
            centered
            title="Leave Testhall?"
            ok
            ok-variant="danger"
            cancel-variant="success"
            @ok="leaveRoute"
            @cancel="stayRoute"
          >
            <template v-slot:modal-ok>
              Ok
            </template>
            <p>Sorry You cannot leave the Testhall until you End your Exam.</p>
          </b-modal>

          <b-modal
            id="modal-submit"
            centered
            ref="sub-modal"
            title="Submit Exam"
            ok
            ok-variant="success"
            cancel-variant="danger"
            @ok="triggerSubmit"
          >
            <template v-slot:modal-ok>
              Yes, Submit
            </template>
            <p>Are you sure you want to end Test?</p>
          </b-modal>
        </b-row>

        <b-row class="p-1">
          <b-col class="p-0">
            <!-- The tabs Wrapper -->
            <b-tabs
              v-if="start_config.structure != 'Untabbed'"
              card
              class="p-0 m-0 tab-title"
              v-model="tabIndex"
              active-nav-item-class="text-light tab-active"
            >
              <!-- Individual Tabs... Determined by the number of sujects in the Subject Array -->
              <b-tab
                class="p-0 m-0"
                v-for="subject in subjects"
                :key="subject"
                title-link-class="text-dark tab-item"
              >
                <template #title>
                  <p class="text-title">
                    {{ subject }}
                  </p>
                </template>
                <!-- Each tabCard holds the only the full details of its Tab. Including all Questions -->
                <!-- 'keysubmitnow' is triggered when the user presses the 's' button. 'opencalcnow' triggers the showing of the Calculator Modal. when the 'm' key is pressed -->
                <!-- 'nexttabnow' & 'previoustabnow' both changes the TabIndex which updates and changes the Tab of Questions being shown to the User. -->
                <tabCard
                  :activeTab="tabIndex"
                  :changeQuestion="changequestion"
                  @itstab="changeTab()"
                  @goupgrade="goToUpgrade()"
                  v-on:keysubmitnow="keysubmitid()"
                  v-on:opencalcnow="opencalcid()"
                  v-on:nexttabnow="nexttabid()"
                  v-on:prevtabnow="prevtabid()"
                ></tabCard>
              </b-tab>
            </b-tabs>

            <b-card v-if="start_config.structure == 'Untabbed'">
              <untabbedCard
                :changeQuestion="changequestion"
                v-on:keysubmitnow="keysubmitid()"
                v-on:opencalcnow="opencalcid()"
              ></untabbedCard>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="8"></b-col>

          <b-col cols="4"></b-col>
        </b-row>
      </b-overlay>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import tabCard from "@/components/tabCard.vue";
import Timer from "@/components/Timer.vue";
import miniTimer from "@/components/miniTimer";
import untabbedCard from "@/components/untabbedCard";

export default {
  components: {
    tabCard,
    Timer,
    miniTimer,
    untabbedCard
  },
  data() {
    return {
      leaving: false,
      tabIndex: 0,
      subchk: "English",
      forcesubmit: false,
      presssub: false,
      submitting: false,
      calcexpre: "",
      result: "",
      questionChanged: false,
      changequestion: false,
      forceLeave: false
    };
  },
  beforeRouteLeave(to, from, next) {
    // Before User leaves the test hall. Prompt the user to know if the test session has really been used up.

    if (this.presssub) {
      next();
    } else if (this.forceLeave) {
      next();
    } else if (this.leaving) {
      next();
    } else {
      // next(false)
      this.$bvModal.show("modal-leave");
    }

    // if (this.leaving) {
    //   next();
    // } else {
    //   next(false);
    // }
  },

  mounted() {
    let self = this; // since the windows object only recognizes the self keyword
    // Perform certain actions on Keyboard events.
    window.addEventListener("keyup", function(ev) {
      switch (ev.key) {
        case "o":
          self.$refs["sub-modal"].hide("cancel");
          break;
        case "y":
          self.$refs["sub-modal"].hide("ok");
          break;
      }
    });
  },
  created() {
    // Forces the MathJax Library on the Testhall to allow for easy showing of Complex equations.
    // This is done because of Chromium Browsers that doesn't allow MathML show on their  browsers
    window.MathJax = {
      MathML: {
        extensions: ["mml3.js", "content-mathml.js"]
      }
    };
    let externalScript = document.createElement("script");
    externalScript.setAttribute(
      "src",
      "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.0/MathJax.js?config=MML_HTMLorMML"
    );
    document.head.appendChild(externalScript);

    // If user is not loggin and finds himself here through url redundanc. Route user to the loggin page.
    if (!this.loggedin) {
      this.$router.push({
        name: "select",
        query: {
          redirect: this.$route.fullPath
        }
      });
    }
    // If test has not started, route user to the select page to select test details.

    if (this.loggedin && !this.started) {
      this.$router.push({
        name: "select"
      });
    }
    // If user has submitted and the user presses back button to the test hall, route user to the select page instead
    if (this.submitted == true) {
      this.$router.push({
        name: "select"
      });
    }
  },

  watch: {
    currentquestionid(oldval, newval) {
      if (oldval != newval) {
        this.questionChanged = true;
      }
    }
  },
  methods: {
    ...mapActions("exam", ["autoSubmission", "destroyStarted"]),

    // If user Presses Back button during a Test session. Prompt user to first submit before exiting the hall.
    // That is only if the user submits or the time elapses before user can leave testhall
    leaveRoute() {
      this.leaving = true;
      this.$bvToast.toast("Submit to Exit Hall", {
        noCloseButton: true,
        solid: true,
        variant: "dark",
        toaster: "b-toaster-bottom-center"
      });
    },
    goToUpgrade() {
      this.forceLeave = true;
      this.$router.push({
          name: "upgrade",
          query: { bypass: 'goland', redirect: this.$route.path }
      })
    },

    // Show a toast after user cancels exiting
    stayRoute() {
      this.$bvToast.toast("Exiting Canceled", {
        noCloseButton: true,
        solid: true,
        variant: "dark",
        toaster: "b-toaster-bottom-center"
      });
    },

    // This handles the submission of the Test when the time elapses. It ensures the test is submitted as soon as the time elapses
    // It reacts to the autoSubmit event emitted by the Timer Component
    autoSubmit() {
      this.submitting = true;

      try{
        this.autoSubmission().then(() => {
          this.forceLeave = true;
          this.submitting = false;
          this.$router.push({
            name: "submitted"
          });
        });
      }catch(err){
        this.submitting = false
      }
      
    },

    // If user Presses the OK button of 'Are you sure you want to Submit', the Submission is then tirggered.
    triggerSubmit() {
      this.forcesubmit = true;
    },

    forceSubmit() {
      this.presssub = true;
      this.$bvModal.show("modal-submit");
    },
    // Calculator function... Add the Text to the Calculator Input Field corresponding to the Button Pressed.
    addText(value) {
      this.calcexpre = this.calcexpre + value;
      this.result = "";
    },
    clearText() {
      this.calcexpre = "";
    },
    // Evaluate the Expression in the Calculator's input field and return The Result
    evalE() {
      if (this.calcexpre.length != 0) {
        let re = /\d{1,}²+/i;
        let re2 = /√\d{1,}/i;
        let oldstr = this.calcexpre;
        let newstr,
          newstr2 = "";

        // Perform Square Function if the Superscript character is detected in the expression
        if (oldstr.includes("²")) {
          let newmatch1 = oldstr.match(re);
          let newstr1i = newmatch1[0].replace("²", "");
          newstr = oldstr.replace(re, `Math.pow(${newstr1i}, 2)`);
        } else {
          newstr = oldstr;
        }

        // Perform Square Root Function if the square root Character is detected in the Expression
        if (oldstr.includes("√")) {
          let newmatch = newstr.match(re2);
          let newstr2i = newmatch[0].replace("√", "");
          newstr2 = newstr.replace(re2, `Math.sqrt(${newstr2i})`);
        } else {
          // If no Square root Character, the Expression is a simple expression. Perform direct evaluation on the basic arithmetic operations
          // +, -, *, /
          newstr2 = newstr;
        }

        // Evaluate the Expression and return the Result
        let result = eval(newstr2);
        this.result = "result";
        this.calcexpre = result;
      }
    },

    // Perform Backspace Function on the Calculator's input field
    delExpression() {
      let flength = this.calcexpre.length;
      let newstr = this.calcexpre.substr(0, flength - 1);
      this.calcexpre = newstr;
    },

    // Forces Submit on Pressing the 's' key
    keysubmitid() {
      this.forceSubmit();
    },
    // Opens the Calculator Modal on pressing the 'm' key
    opencalcid() {
      this.$bvModal.show("modal-calculator");
    },

    // Takes User to the Next tab when user presses the 'n' key
    nexttabid() {
      this.tabIndex = this.tabIndex + 1;
    },

    //Takes user to the previous tab when uer presses the 'p' key
    prevtabid() {
      this.tabIndex = this.tabIndex - 1;
    },
    changeTab() {
      if (this.tabIndex < this.subjects.length - 1) {
        this.tabIndex = this.tabIndex + 1;
      }
    }
  },
  computed: {
    ...mapState({
      started: state => state.exam.started,
      loggedin: state => state.loginmaster.loggedIn,
      subjects: state => state.exam.subjects,
      submitted: state => state.exam.submitted,
      currentquestionid: state => state.exam.currentquestionid,
      start_config: state => state.exam.start_config
    })
  }
};
</script>

<style scoped>
table {
  width: 100%;
  margin-top: 5px;
}

.calctd {
  width: 15%;
}

.calcbtn {
  width: 100%;
  background-color: white;
  color: black;
  border: 1px solid rgba(128, 128, 128, 0.448);
}

.expre {
  font-size: 1.5rem;
}

.result {
  font-weight: bold;
}

.tab-item {
  text-decoration: none;
  color: white;
  background-color: white;
}

.tab-title {
  color: black;
  background-color: white;
}

.flex-actions {
  display: flex;
  position: absolute;
  right: 80px;
  top: 10px;
  /* background-color: red; */
}

.cpoi {
  cursor: pointer;
}

.subbtn {
  background-color: #00984a;
  font-size: 20px;
  font-weight: bold;
  width: 120px;
  border: 0px;
  height: 50px;
}

.tab-active {
  background-color: #15ba1d;
  color: white;
}

.text-title {
  font-weight: bold;
  font-size: 1.4rem;
}

.timer-flexes {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  width: 100%;
}

.timer-flexes-item {
  width: 45%;
}
.title {
  display: absolute;
  font-family: "Roboto";
  color: white;
  font-weight: bold;
  font-size: 1.7rem;
}

@media (max-width: 999px) {
  .flex-actions {
    right: 60px;
    top: 50px;
  }

  .subbtn {
    width: 90px;
    font-size: 15px;
  }

  .text-title {
    font-weight: bold;
    font-size: 0.9rem;
  }

  .cpoi {
    width: 30px;
  }

  .subbtn {
    width: 80px;
    height: 40px;
  }
  .timer-flexes-item {
    margin-top: 12px;
    width: 50%;
  }

  .timer-flexes-item-1 {
    margin-top: 12px;
    width: 100%;
  }
  .timer-flexes-item-2 {
    margin-top: 12px;
    margin-left: 5px;
    width: 100%;
  }

  .subbtn {
    margin-top: 15px;
  }

  .cpoi {
    margin-top: 13px;
  }
}
</style>
